import { excludeUndefined } from '@wix/funnel-utils';
export const addTemplateData = function (flowContext, answers, metadata) {
  if (metadata === void 0) {
    metadata = {};
  }
  return {
    ...flowContext,
    answers: {
      ...flowContext.answers,
      ...answers
    },
    metadata: excludeUndefined({
      ...flowContext.metadata,
      ...metadata
    })
  };
};
//# sourceMappingURL=addTemplateData.js.map